import SwipeableNotification from './swipeable-notification';
import './swipeable-notification.scss';

export default SwipeableNotification;
